import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Menu } from 'antd';
import { loadUsers } from './actions';
import UserListItem from './UserListItem';

class UserList extends Component {
  constructor(props) {
    super(props);
    console.log('in UserList Init');
  }

  componentDidMount() {
    this.props.loadUsers();
  }

  render() {
    const { users } = this.props;
    return (
      <Menu theme="dark" mode="inline">
        {users &&
          users.data &&
          users.data.map((user, index) => (
            <UserListItem user={user} key={`user-item-${index}`} />
          ))}
      </Menu>
    );
  }
}

function mapStateToProps(state) {
  return { users: state.users };
}

function mapDispatchToProps(dispatch) {
  return {
    loadUsers: () => dispatch(loadUsers())
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserList)
);



// WEBPACK FOOTER //
// ./src/modules/Users/UsersList.js